
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.892 15.21c.08-.27.15-.54.2-.82l.03-.18c.05-.33.08-.65.08-.99 0-.55-.07-1.1-.2-1.64l-.03-.13-.01.01c-.75-2.77-3.21-5.02-6.44-5.97l.01-.01-.11-.03-.23-.06c-.07-.02-.14-.04-.21-.05-.23-.05-.46-.1-.69-.14-.09-.02-.18-.03-.27-.05-.23-.04-.46-.06-.69-.09l-.26-.03c-.33-.01-.65-.03-.97-.03-.32 0-.64.02-.96.04l-.26.03c-.23.02-.46.05-.69.08-.09.02-.18.03-.27.05-.23.04-.46.09-.69.14l-.21.06c-.08.01-.15.03-.23.05l-.11.03v.02c-3.89 1.14-6.68 4.17-6.68 7.73 0 1.8.71 3.51 2.05 4.96-.3.76-.75 1.46-1.08 1.92-.2.28-.37.49-.48.62-.06.07-.11.13-.15.17l-.04.03h-.03v.03c-.27.3-.35.74-.19 1.11.16.38.54.63.96.63 2.38 0 4.28-.97 5.45-1.8 1.17.36 2.39.55 3.61.55 4.66 0 8.58-2.59 9.74-6.09.02-.05.04-.1.05-.15zm-4.11 2.35c-1.52 1.17-3.54 1.81-5.68 1.81-1.03 0-2.05-.16-3.03-.47l-.89-.28-.05-.02-.8.57c-.62.44-1.28.79-1.97 1.03.27-.46.48-.92.65-1.35l.41-1.1.02-.06-.85-.9c-.7-.74-1.53-1.97-1.53-3.58 0-1.63.83-3.18 2.34-4.34.85-.65 1.86-1.14 2.95-1.44.41-.11.82-.2 1.25-.26.05-.01.09-.01.14-.02.46-.04.91-.07 1.36-.08.45 0 .9.03 1.34.09.05.01.09.01.14.02.42.06.84.15 1.25.26 1.1.3 2.1.79 2.95 1.44 1.23.94 2 2.14 2.25 3.43.06.28.09.57.09.86v.05c0 .14-.01.27-.02.4 0 .05 0 .1-.01.15-.02.14-.04.28-.07.42-.01.03-.01.07-.02.1-.23.98-.75 1.76-1.24 2.32h.03c-.29.34-.63.66-1.01.95z","fill":"#313131"}})])
          )
        }
      }
    